import store from '@/store.js'
import Vue from 'vue'
import permissions from '@/util/ACL/permissionMap';

export default function(permission, object) {

  let client = store.state.client;
  let user = store.state.user;
  let hasPermission = false;
  let hasOwnPermission = false;
  let permissionName = '';
  let permissionNameOwn = '';


  // Set permissions from parameter
  permissionName = permission[0]
  permissionNameOwn = permission[1]




  if (client && permissionName && permissionNameOwn) {
    // Loop through all user permissions on client
    Vue._.forEach(client.user_permissions, function(userPermission) {

      if (permissionName == userPermission.name){
        // Set Boolean variable to true if permission is matched
        hasPermission = true;
        return true;
      } else if (permissionNameOwn == userPermission.name) {
        // console.log(userPermission.name);
        hasOwnPermission = true
      }
    })




    if (hasOwnPermission) {

      if(permissionNameOwn == permissions.project_CREATE_OWN){
        hasPermission = true;
        return true;
      }
      if (object) {



        // If provided object is user
        if (object.who_am_i == 'App\\Account\\Models\\User') {
          if (object.id == user.id){
            // Set Boolean variable to true if user is matched
            hasPermission = true;
            return true;
          }
        }
        if (object.users) {
          // Check if user is in list of owners
          Vue._.forEach(object.users, function(owner) {
            if (owner.id == user.id){
              // Set Boolean variable to true if user is matched
              hasPermission = true;
              return true;
            }
          })
        }
      }
    }
  }


  // Return Boolean if user has given permission
  return hasPermission;
}
